import SearchBar from './SearchBar';
import ClearSearchButton from './clear-button';

export default { SearchBar, ClearSearchButton };



// WEBPACK FOOTER //
// ./packages/react-bootstrap-table2-toolkit/src/search/index.js